import { Action } from '../../../../../shared/xs/actions';

export class RefreshLogoAction implements Action {
  static readonly type = '[Company] Refresh Logo';
}
